import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "CarsDark__IconWrapper",
  componentId: "sc-1lasxti-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 33 33",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    clipPath: "url(#CarsDark_tsx__a)"
  }, React.createElement("path", {
    fill: themeGet("palette.background.darkest")(themeProps),
    d: "m10.17 24.424 1.082-2.158c.313-.627 1.062-1.037 1.892-1.037h6.274c.82 0 1.559.4 1.882 1.018l1.13 2.177"
  }), React.createElement("path", {
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M16.3 24.424H2.024"
  }), React.createElement("path", {
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.586 10.871H3.004a.98.98 0 0 0 0 1.96H29.6a.98.98 0 0 0 0-1.96h-2.606"
  }), React.createElement("path", {
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M16.3 24.424h14.276"
  }), React.createElement("path", {
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.01 24.423v3.19H2.024v-9.801c0-1.603.618-3.138 1.718-4.3l.652-.686 3.098-5.183a3.03 3.03 0 0 1 2.775-1.815h11.97c1.187 0 2.263.69 2.755 1.771l3.2 5.227.956 1.004c.786.825 1.428 2.432 1.428 3.571v10.213h-4.985v-3.19"
  }), React.createElement("path", {
    fill: themeGet("palette.background.darkest")(themeProps),
    d: "M22.84 19.08c.202-.771 1.858-2.644 4.107-2.644.526 0 1.066.169 1.245.676.178.507.28 1.173.116 2.065a1.01 1.01 0 0 1-.83.802c-.826.135-2.327.29-4.02-.005-.42-.073-.725-.483-.618-.893M9.66 19.08c-.204-.771-1.859-2.644-4.108-2.644-.526 0-1.067.169-1.245.676s-.28 1.173-.116 2.065c.077.415.415.734.83.802.825.135 2.326.29 4.02-.005.42-.073.724-.483.618-.893"
  }), React.createElement("path", {
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.052 19.148h6.395"
  }), React.createElement("path", {
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.428 12.83a2.5 2.5 0 0 1 2.505-2.504 2.5 2.5 0 0 1 2.505 2.504"
  }), React.createElement("path", {
    fill: themeGet("palette.background.darkest")(themeProps),
    d: "M2.024 24.82v2.799H7.01v-3.195zM25.89 25.022v2.794h4.985v-3.19z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "CarsDark_tsx__a"
  }, React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    d: "M1.3 5.109h30v23.234h-30z"
  }))));
}
const CarsDark = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(CarsDark);
export default Memo;